// Chinese (Simplified) — zh-Hans
export default {
  // --- Shell / nav ---
  app_name: '潮汐在身边',
  search_stations: '搜索站点',
  search_stations_hint: '搜索站点 (⌘K)',
  settings: '设置',
  app_store: '在 App Store 下载',
  google_play: '在 Google Play 获取',
  app_promo_title: '下载免费应用，速度更快 🙂',
  app_promo_body: '同样的潮汐和潮流预报，就在手机上。',
  privacy: '隐私',
  terms: '条款',
  data_sources: '数据来源',
  support: '支持',

  guides: '指南',
  // --- Home ---
  home_title: '查找附近的潮汐和潮流',
  by_country: '按国家/地区',
  favorite_tides: '喜爱的潮汐',
  recent_tides: '最近的潮汐',
  nearby_tides: '附近的潮汐',
  favorite_currents: '喜爱的潮流',
  recent_currents: '最近的潮流',
  nearby_currents: '附近的潮流',
  favorite_charts: '喜爱的海图',
  recent_charts: '最近的海图',
  nearby_charts: '附近的海图',
  finding_stations: '正在查找您附近的站点…',
  distance_away: '{{distance}} 远',

  // --- Search overlay ---
  search_placeholder: '搜索站点…',
  tide_stations: '潮汐站',
  current_stations: '潮流站',
  recents: '最近的',
  search_unavailable: '搜索当前不可用。',
  no_stations_found: '未找到站点。',
  search_prompt: '按名称搜索潮汐和潮流站。',

  // --- Settings ---
  appearance: '外观',
  appearance_system: '跟随系统',
  appearance_light: '浅色',
  appearance_dark: '深色',
  tide_height: '潮汐高度',
  unit_feet: '英尺',
  unit_meters: '米',
  distance: '距离',
  unit_miles: '英里',
  unit_kilometers: '公里',
  recent_stations: '最近的站点',
  clear_recents: '清空最近记录',
  currents: '潮流',
  nautical_charts: '海图',
  browse_by_country: '按国家/地区浏览',
  countries_auto: '自动',
  countries_always: '始终显示',
  countries_never: '不显示',
  show: '显示',
  hide: '隐藏',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}} 潮汐',
  current_title: '{{name}} 潮流',
  last_tide: '上次潮汐',
  next_tide: '下次潮汐',
  coefficient: 'Coef',
  last_current: '上次潮流',
  next_current: '下次潮流',
  following_current: '下一股潮流',
  high: '高位',
  low: '低位',
  tides: '潮汐',
  sun: '太阳',
  moon: '月亮',
  sunrise_now: '日出',
  sunset_now: '日落',
  moonrise_now: '月出',
  moonset_now: '月落',
  sunrise_week: '日出',
  sunset_week: '日落',
  moonrise_week: '月出',
  moonset_week: '月落',
  add_to_favorites: '添加到收藏',
  remove_from_favorites: '从收藏中移除',

  // --- Week table dates ---
  today: '今天',
  tomorrow: '明天',

  // --- Moon phases ---
  phase_new_moon: '新月',
  phase_waxing_crescent: '娥眉月',
  phase_first_quarter: '上弦月',
  phase_waxing_gibbous: '盈凸月',
  phase_full_moon: '满月',
  phase_waning_gibbous: '亏凸月',
  phase_last_quarter: '下弦月',
  phase_waning_crescent: '残月',

  // --- Tide / current status vocabulary ---
  rising: '上涨中',
  falling: '下降中',
  high_tide: '高潮',
  low_tide: '低潮',
  ebb: '潮退',
  flood: '涨潮',
  slack: '潮憩',

  // --- Relative time ---
  just_now: '刚刚',
  somethings_wrong: '发生错误',
  hour_ago: '{{hour}} 小时前',
  hours_ago: '{{hour}} 小时前',
  minute_ago: '{{minute}} 分钟前',
  minutes_ago: '{{minute}} 分钟前',
  hour_minute_ago: '{{hour}} 小时 {{minute}} 分钟前',
  hour_minutes_ago: '{{hour}} 小时 {{minute}} 分钟前',
  hours_minute_ago: '{{hour}} 小时 {{minute}} 分钟前',
  hours_minutes_ago: '{{hour}} 小时 {{minute}} 分钟前',
  hour_from_now: '{{hour}} 小时后',
  hours_from_now: '{{hour}} 小时后',
  minute_from_now: '{{minute}} 分钟后',
  minutes_from_now: '{{minute}} 分钟后',
  hour_minute_from_now: '{{hour}} 小时 {{minute}} 分钟后',
  hour_minutes_from_now: '{{hour}} 小时 {{minute}} 分钟后',
  hours_minute_from_now: '{{hour}} 小时 {{minute}} 分钟后',
  hours_minutes_from_now: '{{hour}} 小时 {{minute}} 分钟后',

  // --- Insights ---
  insights_7_day_overview: '7天洞察',
  no_insights_available: '该站点没有可用的分析。',
  insights_current_extremes: '潮流极值',
  insights_fastest_flood: '最快涨潮',
  insights_fastest_ebb: '最快落潮',
  insights_strongest_daily_currents: '每日峰值潮流',
  insights_fastest_current: '最快',
  insights_slowest_current: '最慢',
  insights_tidal_extremes: '潮汐极值',
  insights_highest_tide: '最高潮位',
  insights_lowest_tide: '最低潮位',
  insights_strongest_daily_movements: '最大潮差范围',
  insights_largest_tide: '最大',
  insights_smallest_tide: '最小',
  insights_value_at_time: '{{time}} {{value}}',
  insights_tidal_range_label: '潮差',
  insights_max_current_label: '最大潮流',

  // --- Insight bands ---
  band_smaller_than_usual: '小于通常',
  band_typical: '正常',
  band_larger_than_usual: '大于通常',
  band_unusually_large: '异常大',
  band_lower_than_usual: '低于往常',
  band_unusually_low: '异常低',
  band_slower_than_usual: '慢于通常',
  band_faster_than_usual: '快于通常',
  band_unusually_fast: '异常快',
  band_smaller_than_usual_height: '比平常低',
  band_larger_than_usual_height: '比平常高',
  band_unusually_large_height: '异常高',

  // --- Map attribution ---
  attribution: '版权归属',
  attribution_osm: '地图数据 © OpenStreetMap 贡献者',
  attribution_tiles: '地图瓦片由 OpenFreeMap 提供',
  attribution_style: '地图样式 © OpenMapTiles',
  ok: '确定',

  // --- Explore map ---
  current_speed: '潮流速度',
  depth: '水深',
  speed: '航速',
  depth_datum: '深度基准:',
  depth_drying: '干出',
  depth_loading: '正在加载水深数据…',
  depth_datum_tag: '水深以 {{unit}} 计，基准面 {{datum}}',
  depth_not_for_navigation: '不可用于导航。',
  depth_unavailable: '水深数据暂时不可用。',
  depth_unit_m: '米',
  depth_unit_ft: '英尺',
  go_mode_start: '出发',
  go_mode_start_label: '开始',
  go_mode_exit: '退出',
  go_mode_location_denied: 'Go 模式需要您的位置信息。请通过锁定图标启用。',
  go_mode_location_denied_ok: '确定',
  radar: '雷达',
  radar_precipitation: '降水',
  radar_light: '小',
  radar_moderate: '中',
  radar_heavy: '大',
  radar_storm: '暴雨',
  radar_forecast: '预报',
  radar_none_for_time: '该时间无雷达数据',
  now: '现在',
  explore_prompt_denied: '本站的位置信息已关闭：请通过地址栏中的锁定图标启用。',
  open_full_map: '打开完整地图',
  close_full_map: '关闭完整地图',
  explore_full_map: '浏览完整地图',
  center_on_location: '定位到我的位置',
  show_my_location: '显示我的位置',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: '州',
  no_stations_found_location: '未找到站点。',
  tides_and_currents_by_country: '按国家/地区查看潮汐和潮流',

  // --- SEO titles / descriptions ---
  settings_seo_description: '选择潮汐高度和距离的单位。',
  tide_seo_description: '{{name}}{{location}}的潮汐预测、高潮和低潮时间。',
  current_seo_description: '{{name}}{{location}}的潮流预测、涨潮和落潮时间。',
  location_title: '{{name}} 潮汐和潮流',
  country_seo_description:
    '{{name}}的潮汐时间和潮流预测。浏览{{name}}各地的{{stateTerm}}和沿海潮汐站。',
  state_seo_description:
    '{{name}}（{{country}}）的潮汐和潮流预测。{{name}}沿海站点的高潮和低潮时间。',
  city_seo_description: '{{place}}的潮汐时间和潮流预测。{{name}}附近的高低潮汐和潮流。',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: '{{name}}的海图',
  chart_intro:
    '{{title}}的免费海图。提供实测水深、浮标、立标、礁石、沉船、游艇码头、锚地和潮汐站点。',
  chart_page_name: '{{title}} 海图',
  chart_seo_description:
    '{{title}}的免费海图。提供实测水深、浮标、立标、礁石、沉船、游艇码头、锚地和潮汐站点。',

  countries_seo_title: '按国家/地区查看潮汐和潮流站',
  countries_seo_description:
    '按国家/地区浏览潮汐和潮流站。查看全球沿海地点的高低潮时间和潮流预报。',
  home_seo_description:
    '查找您附近沿海潮汐站的潮汐时间和潮流预测。查看您所在位置的高低潮，或按国家/地区浏览潮汐站。',
  explore_play: '播放',
  explore_pause: '暂停',
  explore_playback_speed: '播放速度',
  explore_time: '时间',
  skip_to_content: '跳到主要内容',
  // --- Weather (station pages) ---
  weather: '海洋天气',
  wind: '风',
  gusts: '阵风',
  seas: '海浪',
  time: '时间',
  air_temp: '气温',
  water_temp: '水温',
  water_temperature: '水温',
  humidity: '湿度',
  pressure: '气压',
  precip_chance: '降水概率',
  chances: '概率',
  precip_rate: '降水强度',
  visibility: '能见度',
  condition_thunderstorms: '雷暴',
  condition_freezing_rain: '冻雨',
  condition_sleet: '雨夹雪',
  condition_snow: '雪',
  condition_fog: '雾',
  condition_rain: '雨',
  condition_cloudy: '阴',
  condition_partly_cloudy: '多云',
  condition_clear: '晴',
  weather_thunder: '雷',
  note_seas_computed_from_wind: '浪高根据风和海岸线估算。',
  note_seas_from_nearby_open_water: '海况数据来自附近开阔水域。',
  note_seas_open_water_nearby: '附近开阔水域的浪高约为{{height}}。此处可能更平静。',
  note_seas_open_water_distant: '{{distance}}外开阔水域的浪高约为{{height}}。此处可能更平静。',
  note_seas_open_water_distant_dir:
    '{{direction}}方向{{distance}}外开阔水域的浪高约为{{height}}。此处可能更平静。',
  note_seas_unavailable: '该点没有可靠的海况数据。',
  note_sheltered_water_sees_less: '遮蔽水域的海况通常小于这些开阔水域数值。',
  note_no_warning_feed_coverage: '没有官方海上警报服务覆盖该点。',
  note_nearest_point_across_land: '最近的预报点隔着陆地。',
  warnings_none_active: '当前没有生效的海上警报',
  warnings_unavailable: '该位置无法提供海上警报',
  warning_show_text: '显示官方原文',
  warning_hide_text: '隐藏官方原文',
  weather_updated: '更新于 {{time}}',
  current_conditions: '当前状况',
  daily_forecast: '每日预报',
  expand_for_hourly: '展开查看逐小时预报',
  hourly: '每小时',
  hourly_forecast: '逐小时预报',
  wind_speed: '风速',
  wind_gusts: '风及阵风',
  pressure_humidity: '气压和湿度',
  max_seas: '最大浪高',
  visibility_excellent: '极佳',
  visibility_good: '良好',
  visibility_moderate: '一般',
  visibility_poor: '较差',
  forecaster_text_link: '{{issuer}} 预报原文',
  temperature: '温度',
  unit_fahrenheit: '华氏 (°F)',
  unit_celsius: '摄氏 (°C)',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}}～{{end}}',
  warning_window_open: '{{start}}～',
  range_separator_short: '～',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: '周期',
  wave_period_short: '{{period}}秒',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: '北',
  compass_NNE: '东北偏北',
  compass_NE: '东北',
  compass_ENE: '东北偏东',
  compass_E: '东',
  compass_ESE: '东南偏东',
  compass_SE: '东南',
  compass_SSE: '东南偏南',
  compass_S: '南',
  compass_SSW: '西南偏南',
  compass_SW: '西南',
  compass_WSW: '西南偏西',
  compass_W: '西',
  compass_WNW: '西北偏西',
  compass_NW: '西北',
  compass_NNW: '西北偏北',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: '小型船只警报',
  warning_type_gale_warning: '海上大风警报',
  warning_type_gale_watch: '海上大风预警',
  warning_type_storm_warning: '风暴警报',
  warning_type_storm_watch: '风暴预警',
  warning_type_hurricane_force_wind_warning: '飓风级大风警报',
  warning_type_hurricane_force_wind_watch: '飓风级大风预警',
  warning_type_special_marine_warning: '特别海上警报',
  warning_type_marine_weather_statement: '海上天气通报',
  warning_type_hazardous_seas_warning: '危险海况警报',
  warning_type_brisk_wind_advisory: '清劲风提示',
  warning_type_low_water_advisory: '低水位提示',
  warning_type_dense_fog_advisory: '浓雾提示',
  warning_type_heavy_freezing_spray_warning: '强飞沫结冰警报',
  warning_type_strong_wind_warning: '强风警报',
  warning_type_gale_force_wind_warning: '海上大风警报',
  warning_type_storm_force_wind_warning: '风暴警报',
  warning_type_wind_warning: '海上风警报',
  warning_type_dense_fog_warning: '浓雾警报',
  warning_type_icing_warning: '积冰警报',
  warning_type_typhoon_warning: '台风警报',
  warning_type_wind_wave_warning: '风浪警报',
  warning_type_wind_wave_advisory: '风浪提示',
  warning_type_strong_wind_advisory: '强风提示',
  warning_type_storm_surge_warning: '风暴潮警报',
  warning_type_storm_surge_advisory: '风暴潮提示',
  warning_type_thunderstorm_warning: '雷暴警报',
  warning_type_rough_sea_warning: '大浪警报',
  warning_type_fog_warning: '大雾警报',
  sea_state_calm_rippled: '微波',
  sea_state_smooth: '平静海面',
  sea_state_slight: '轻浪',
  sea_state_moderate: '中浪',
  sea_state_rough: '大浪',
  sea_state_very_rough: '巨浪',
  sea_state_high: '狂浪',
  sea_state_very_high: '狂涛',
  sea_state_phenomenal: '怒涛',
  hazard_showers: '阵雨',
  hazard_reduced_visibility: '能见度差',
  hazard_haze: '轻雾',
  hazard_waterspout: '水龙卷',
  hazard_freezing_spray: '冻雾凇',
  hazard_ice: '结冰',
  marine_summary_sea_wind: '{{sea}}，{{direction}}风 {{speed}}。',
  marine_summary_wind_only_gusting: '{{direction}}风 {{speed}}，阵风 {{gust}}。',
  marine_summary_sea_wind_gusting: '{{sea}}，{{direction}}风 {{speed}}，阵风 {{gust}}。',
  marine_summary_wind_only: '{{direction}}风 {{speed}}。',
  marine_summary_sea_only: '{{sea}}。',
  marine_prediction_caveat_tide_one: '潮汐预报仅为天文潮，该警报中的天气可能使实际水位升高或降低。',
  marine_prediction_caveat_tide_many:
    '潮汐预报仅为天文潮，这些警报中的天气可能使实际水位升高或降低。',
  marine_prediction_caveat_current_one:
    '潮流预报仅为天文潮，该警报中的天气可能使实际流速增强或减弱。',
  marine_prediction_caveat_current_many:
    '潮流预报仅为天文潮，这些警报中的天气可能使实际流速增强或减弱。',
  marine_warning_active: '本海区发布海上警报。',
  marine_warnings_active: '本海区发布多项海上警报。',
  marine_warning_upcoming: '本海区自{{time}}起发布海上警报。',
  marine_warnings_upcoming: '本海区自{{time}}起发布多项海上警报。',
  marine_summary_hazard_now: '当前有{{hazard}}。',
  marine_summary_hazard_later: '预报有{{hazard}}。',
  marine_tide_rising: '潮位 {{height}}，正在涨潮：下次高潮 {{time}}，{{next}}。',
  marine_tide_falling: '潮位 {{height}}，正在落潮：下次低潮 {{time}}，{{next}}。',
  marine_current_flood: '下次涨潮流 {{time}}，{{speed}}。',
  marine_current_ebb: '下次落潮流 {{time}}，{{speed}}。',
  marine_current_slack: '下次转流 {{time}}。',
  marine_current_now_flood: '涨潮流 {{speed}}。',
  marine_current_now_ebb: '落潮流 {{speed}}。',
  marine_current_now_slack: '转流。',
  marine_current_peak: '最强 {{time}}，{{speed}}。',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: '灯标',
  furn_buoy: '浮标',
  furn_beacon: '立标',
  furn_wreck: '沉船',
  furn_rock: '礁石',
  furn_obstruction: '障碍物',
  furn_anchorage: '锚地',
  furn_tss: '分道通航制',
  furn_routing: '航路指定',
  furn_title_buoy: '{{category}}浮标',
  furn_title_beacon: '{{category}}立标',
  furn_cat_port: '左侧',
  furn_cat_starboard: '右侧',
  furn_cat_preferred_channel_port: '首选航道左侧',
  furn_cat_preferred_channel_starboard: '首选航道右侧',
  furn_cat_safe_water: '安全水域',
  furn_cat_isolated_danger: '孤立危险物',
  furn_cat_north: '北方位',
  furn_cat_east: '东方位',
  furn_cat_south: '南方位',
  furn_cat_west: '西方位',
  furn_cat_special: '专用',
  furn_cat_mooring: '系泊',
  furn_cat_lateral: '侧面',
  furn_characteristic: '灯质',
  furn_range: '射程',
  furn_height: '高度',
  furn_colour: '颜色',
  furn_shape: '形状',
  furn_lights_on_mark: '此标志上的灯光',
  furn_topmark: '顶标',
  furn_class: '类别',
  furn_least_depth_over: '最浅水深',
  furn_depth_over: '上方水深',
  furn_state: '状态',
  furn_type: '类型',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: '海底电缆',
  furn_pipeline: '海底管道',
  furn_restricted_area: '限制区域',
  furn_restriction: '限制',
  furn_mpa: '海洋保护区',
  furn_protection: '保护级别',
  furn_agency: '管理机构',
  furn_mpa_note: '这是保护区划定，不是航行限制。',
  furn_sector: '分弧',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: '{{colour}}定光。',
  lightw_fl: '每{{period}}秒{{colour}}闪光一次。',
  lightw_fl_group: '每{{period}}秒{{colour}}群闪（{{count}}次）。',
  lightw_lfl: '每{{period}}秒一次{{colour}}长闪。',
  lightw_q: '{{colour}}急闪。',
  lightw_iso: '明暗等长的{{colour}}等明暗光，周期{{period}}秒。',
  lightw_oc: '每{{period}}秒短暂遮蔽的{{colour}}明暗光。',
  lightcolour_white: '白色',
  lightcolour_red: '红色',
  lightcolour_green: '绿色',
  lightcolour_yellow: '黄色',
  furn_feet_charted_value: '{{feet}} ft（海图标注 {{metres}} m）',
  furn_light_yes: '有',
  furn_shown_neutral: '{{colours}}（以中性色显示）',
  furn_note_light: '灯光在夜间的显示方式，航海者以此识别。',
  furn_note_lateral_b_port: '标示自海上进港时航道的左侧（IALA B：绿色罐形）。',
  furn_note_lateral_b_starboard: '标示自海上进港时航道的右侧（IALA B：进港时红标在右）。',
  furn_note_lateral_a_port: '标示自海上进港时航道的左舷一侧（IALA A：左舷为红）。',
  furn_note_lateral_a_starboard: '标示自海上进港时航道的右舷一侧（IALA A：右舷为绿）。',
  furn_note_safe_water: '四周均为安全水域，通常是引航标或航道中央标。',
  furn_note_isolated_danger: '设置在四周可通航水域中的孤立危险物之上。',
  furn_note_cardinal_north: '方位标：请从其北侧通过。',
  furn_note_cardinal_east: '方位标：请从其东侧通过。',
  furn_note_cardinal_south: '方位标：请从其南侧通过。',
  furn_note_cardinal_west: '方位标：请从其西侧通过。',
  furn_note_special: '专用标（黄色）：界限、海底电缆、系泊、比赛等。',
  furn_note_preferred_starboard: '分汊标志：主航道位于右舷一侧。',
  furn_note_preferred_port: '分汊标志：主航道位于左舷一侧。',
  furn_note_mooring: '系泊浮标。',
  furn_vessel: '船舶',
  furn_depth_quality: '水深质量',
  furn_length: '长度',
  furn_position_accuracy: '定位精度',
  furn_remarks: '备注',
  furn_circumstances: '情况',
  furn_status: '状态',
  furn_note_shom: '由法国海道测量局（Shom）测绘。©Shom, CC BY-SA 4.0。',
  furn_lock: '船闸',
  furn_bridge: '桥梁',
  furn_overhead_cable: '架空缆线',
  furn_notice_mark: '告示标志',
  furn_distance_mark: '里程标',
  furn_daymark: '日间标志',
  furn_channel: '航道',
  furn_vertical_clearance_closed: '垂直净空（关闭）',
  furn_vertical_clearance_open: '垂直净空（开启）',
  furn_datum: '基准面',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    '内河电子航道图（美国陆军工程兵团）。净空为上述基准面以上的高度；河水上涨时实际净空更小。',
  furn_note_wreck: '海图标注的沉船。水深为海图值，未经核实。',
  furn_note_anchorage: '海图标注的锚地。',
  furn_note_tss: '单向航道。小型船舶应垂直穿越并保持避让。',
  furn_route: '航路',
  furn_fairway: '航道',
  furn_recommended_track: '推荐航线',
  furn_navigation_line: '航行线',
  furn_leading_line: '导标线',
  furn_clearing_line: '安全线',
  furn_transit_line: '通航线',
  furn_traffic: '通航',
  furn_orientation: '方位',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: '海图标绘的航道，为维护或首选的通航水道。',
  furn_note_track: '海图标绘的航向线。',
  furn_note_track_fixed_marks: '海图标绘的航向线，以固定标志（叠标）为基准。',
  furn_note_leading_line: '保持导标叠合，即可沿海图标绘的线航行。',
  furn_note_navigation_line: '海图标绘的航行线。',
  furn_poi_marina: '游艇码头',
  furn_poi_fuel: '燃油',
  furn_poi_slipway: '下水滑道',
  furn_poi_ferry_terminal: '轮渡码头',
  furn_poi_boatyard: '船厂',
  furn_poi_lighthouse: '灯塔',
  furn_note_slipway: '下水滑道。',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: '跟随我的朝向',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: 此处无数据',
  ww_row_no_forecast_after: '{{row}}: {{when}}之后无预报',
  ww_row_no_forecast: '{{row}}: 没有更远的预报',
  ww_unavailable: '天气信息不可用',
  explore_show_player: '显示时间轴',
  explore_hide_player: '隐藏时间轴',

  // ROUTE PLANNING on /explore (2026-10-23). Describe, never advise; never
  // "safe". route_disclaimer is only the fallback when the service's response
  // carries no disclaimer of its own.
  route_plan: '规划航线',
  route_leave: '退出航线规划',
  route_title: '航线',
  route_prompt_start: '点按你要出发的水面。',
  route_prompt_start_desktop: '点击你要出发的水面，然后点击目的地。',
  route_prompt_end: '起点已设置。现在点按目的地。',
  route_prompt_end_desktop: '起点已设置。现在点击目的地。',
  route_drag_hint: '图钉可以拖动。',
  route_clear: '清除',
  route_swap: '交换起点和目的地',
  route_share: '复制链接',
  route_copied: '链接已复制',
  route_start: '起点',
  route_destination: '目的地',
  route_near: '{{name}}附近',
  route_loading: '正在规划航线…',
  route_loading_sub: '通常只需一两秒。部分水域最长需要 30 秒。',
  route_loading_slow: '仍在处理…',
  route_loading_slow_sub: '此水域耗时比平常更长。',
  route_summary_time: '{{duration}}（航速 {{speed}}）',
  route_planning_speed: '规划航速',
  route_shoalest: '航线最浅处',
  route_planning_draft: '规划吃水',
  route_change: '更改',
  route_draft_title: '规划吃水',
  route_draft_help:
    '这是规划航线所用的水深，不是你船的吃水。设得越深，可行航线越少；设得越浅，可行航线越多。',
  route_datum: '水深以海图基准面（MLLW）为准，未计入潮汐。',
  route_unassured_note: '橙色航段经过海图和测量无法分辨是否浅于 {{draft}} 的水域。',
  route_row_start: '出发 {{label}}',
  route_row_heading: '航向 {{course}}°（{{point}}）',
  route_row_end: '到达 {{label}}',
  route_row_end_sub: '航线终点',
  route_turn_left: '左转至 {{course}}°',
  route_turn_right: '右转至 {{course}}°',
  route_bear_left: '向左偏转至 {{course}}°',
  route_bear_right: '向右偏转至 {{course}}°',
  route_then: '{{first}}，然后{{second}}',
  route_keep_mark: '保持{{mark}}在你的{{hand}}侧',
  route_leave_channel: '在{{mark}}处驶离航道',
  route_on_your: '在你的{{hand}}侧（{{side}}）',
  route_hand_left: '左',
  route_hand_right: '右',
  route_side_port: '左舷',
  route_side_starboard: '右舷',
  route_mark_buoy: '{{color}}色浮标 {{num}}',
  route_mark_light: '{{color}}色灯标 {{num}}',
  route_mark_daybeacon: '{{color}}色立标 {{num}}',
  route_mark_lighted: '{{mark}}（带灯）',
  route_red: '红',
  route_green: '绿',
  route_follow: '沿{{name}}航行',
  route_follow_two: '沿{{first}}航行，然后沿{{second}}',
  route_follow_channel: '{{name}}航道',
  route_follow_named: '{{name}}',
  route_follow_unnamed: '有标志的航道',
  route_follow_marks: '{{count}} 个标志',
  route_greens_on: '绿标在你的{{hand}}侧',
  route_reds_on: '红标在你的{{hand}}侧',
  route_show_marks: '显示标志',
  route_hide_marks: '隐藏标志',
  route_why: '为什么在这里转向？',
  route_turn_reason: '在此转向的原因：{{reason}}',
  route_lights: '射程内的灯光：{{lights}}',
  route_stretch_unassured: '无法分辨是否浅于 {{draft}}',
  route_stretch_rocky: '位于海图标绘的礁石之间',
  route_stretch_canal: '运河：未考虑船闸运行、闸门和桥梁净空',
  route_step_of: '第 {{n}} 步，共 {{total}} 步',
  route_all_steps: '全部步骤',
  route_prev_step: '上一步',
  route_next_step: '下一步',
  route_minutes: '{{n}} 分钟',
  route_hours: '{{h}} 小时',
  route_hours_minutes: '{{h}} 小时 {{m}} 分钟',
  route_err_on_land_origin: '起点位于海图上的陆地',
  route_err_on_land_destination: '目的地位于海图上的陆地',
  route_err_on_land_origin_sub: '将起点图钉拖到水面上。在海图上，沼泽、海滩或码头都算作陆地。',
  route_err_on_land_destination_sub:
    '将目的地图钉拖到水面上。在海图上，沼泽、海滩或码头都算作陆地。',
  route_err_no_route: '规划吃水 {{draft}} 时没有可行航线',
  route_err_no_route_sub: '两点之间某处的海图水深浅于 {{draft}}。减小规划吃水也许能找到航线。',
  route_err_no_snap: '其中一个点附近没有海图标绘的水域',
  route_err_no_snap_sub: '将图钉移到更靠近开阔水域的位置。',
  route_err_outside: '航线规划目前仅覆盖美国水域',
  route_err_outside_sub: '航线基于 NOAA 海图生成，因此两个点都必须位于美国水域。更多海岸稍后推出。',
  route_err_timeout: '航线服务响应超时',
  route_err_timeout_sub: '部分水域最长需要 30 秒，此次已超时。',
  route_err_unavailable: '航线规划暂时不可用',
  route_err_unavailable_sub: '请稍后再试。',
  route_err_busy: '航线请求过多',
  route_err_busy_sub: '请等待一分钟后再试。',
  route_try_again: '重试',
  route_disclaimer: '不可用于航行。此航线沿海图标绘的有标志航道；这并非声明该水域安全。',
  route_promo_title: '在应用中用 Go Mode 跟随此航线',
  route_promo_body:
    'Go Mode 会在海图上持续显示你的船，并显示到下一个标志或转向点的距离、船下水深，以及最近站点的潮汐和潮流。适用于 iPhone 和 Android 版“潮汐在身边”，需订阅。',
}
